"use strict";
//
// Copyright © 2023 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractReferences = extractReferences;
const model_1 = require("../markup/model");
const traverse_1 = require("../markup/traverse");
/**
 * @public
 */
function extractReferences(content) {
    const result = [];
    (0, traverse_1.traverseNode)(content, (node, parent) => {
        if (node.type === model_1.MarkupNodeType.reference) {
            const reference = node;
            const objectId = reference.attrs.id;
            const objectClass = reference.attrs.objectclass;
            const e = result.find((e) => e.objectId === objectId && e.objectClass === objectClass);
            if (e === undefined) {
                result.push({ objectId, objectClass, parentNode: parent ?? node });
            }
        }
        return true;
    });
    return result;
}
//# sourceMappingURL=reference.js.map